import { h } from 'preact'
import { CHAT_INVOLVEMENTS } from '@tshmanager/chat-shared'
import { chatApi } from '../chat-api.js'
import { t } from '../chat-i18n.js'

/**
 * Per-room notification level (everything / mentions / nothing).
 * Props: { room, store, open, onClose, onUpdated }
 */
export function InvolvementMenu({ room, store, open, onClose, onUpdated }) {
  if (!open || !room?.id) return null

  const current = room.involvement || 'mentions'

  async function selectLevel(level) {
    if (level === current) {
      onClose()
      return
    }

    const roomId = room.id
    const previous = current
    store.rooms.value = store.rooms.value.map(r =>
      r.id === roomId ? { ...r, involvement: level } : r
    )

    try {
      const res = await chatApi.rooms.updateInvolvement(roomId, level)
      if (res.ok) {
        const updated = await res.json
        onUpdated(updated)
      } else {
        store.rooms.value = store.rooms.value.map(r =>
          r.id === roomId ? { ...r, involvement: previous } : r
        )
      }
    } catch {
      store.rooms.value = store.rooms.value.map(r =>
        r.id === roomId ? { ...r, involvement: previous } : r
      )
    } finally {
      onClose()
    }
  }

  return (
    <div class="chat-involvement-menu" role="menu">
      <div class="chat-involvement-menu-title">{t('chat.rooms.notifications_title')}</div>
      {CHAT_INVOLVEMENTS.map(level => (
        <button
          key={level}
          type="button"
          role="menuitemradio"
          aria-checked={current === level}
          class={`chat-involvement-menu-item${current === level ? ' chat-involvement-menu-item--active' : ''}`}
          onClick={() => selectLevel(level)}
        >
          <span>{t(`chat.rooms.involvement.${level}`)}</span>
          {current === level && <i class="bi bi-check-lg" />}
        </button>
      ))}
    </div>
  )
}

/** Header icon class for current involvement (everything / mentions / nothing). */
export function involvementBellIcon(involvement) {
  switch (involvement || 'mentions') {
    case 'everything': return 'bi-bell'
    case 'nothing':    return 'bi-bell-slash'
    default:           return 'bi-at'
  }
}
